import type { ApiImage } from '@nutralab/api';

/** The path of an image's original file: a stable id of the image, whatever format the backend sends. */
export function getImagePath(image: ApiImage): string {
    return typeof image === 'string' ? image : image.original;
}
